export const getHTMLFromText = (html: string): JSX.Element => (
  <span dangerouslySetInnerHTML={{ __html: html }} />
);
